import { Link } from "react-router-dom";
import type { Drama } from "@/types/drama";

type Props = {
  drama: Drama;
  hideSummary?: boolean;
};

export default function DramaCard({ drama, hideSummary = false }: Props) {
  return (
    <Link to={`/detail/${drama.id}`} className="group block cursor-pointer">
      <div className="relative w-full overflow-hidden rounded-lg border border-background-200/70 bg-background-100">
        <div className="aspect-[2/3] w-full overflow-hidden">
          <img
            src={drama.cover}
            alt={`${drama.title} 剧集封面`}
            title={`${drama.title} 剧情介绍与角色分析`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/30 to-transparent"></div>
        <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded bg-background-50/80 px-2 py-0.5 font-label text-[11px] text-accent-500">
          <i className="ri-star-fill text-[10px]"></i>
          {drama.rating.toFixed(1)}
        </span>
        <span className="absolute right-2.5 top-2.5 rounded bg-primary-500/90 px-2 py-0.5 font-label text-[11px] text-background-50">
          {drama.types[0]}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
            {drama.title}
          </h3>
          <p className="mt-1 font-label text-[11px] text-foreground-500">
            {drama.year} · {drama.region} · {drama.episodeCount} 集
          </p>
        </div>
      </div>
      {!hideSummary && (
        <>
          <p className="mt-2.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 transition-colors group-hover:text-foreground-700">
            {drama.tagline}
          </p>
          <p className="mt-1.5 line-clamp-1 font-label text-[11px] text-foreground-500">
            主演：{drama.cast.join(" / ")}
          </p>
        </>
      )}
    </Link>
  );
}